import axios from 'axios'
import React, { useEffect, useState } from 'react'
import './GetAllTheatres.css'
import { Link } from 'react-router-dom';
import BASE_URL from '../../constant';

function GetAllTheatres() {

  const [theatreList, setTheatreList] = useState([]);
  const [showsData, setShowData] = useState({});
  const [disStyle, setDisStyle] = useState({});

  
  const storedAdmin = JSON.parse(localStorage.getItem("adminData"));
  const [logStatus, setLogStatus] = useState(true);

  useEffect(()=>{
    if(!storedAdmin){
      setLogStatus(false)
      return
    }
      axios.get(`${BASE_URL}/bookmyshow/api/v1/theatre`)
      .then(res => {
          setTheatreList(res.data);
      })
  },[storedAdmin])

  const getShows = (theatreId)=>{
    axios.get(`${BASE_URL}/bookmyshow/api/v1/shows/theatre-shows/${theatreId}`)
    .then(res => {
      setShowData(res.data);
      setDisStyle({
        display : "block"
      });
    })
    .catch(err => console.log(err));
  }

  return (
    <div>
    {(!logStatus) ? "Unauthorised access" : <div className='allTheatres'>
      <div className="showOfmovie" style={disStyle}>
        <button className="close" 
        onClick={()=>{setDisStyle({display : "none"})}}>
          <i className='fa-solid fa-close'></i>
        </button>
      <div className="theatreName">{
        showsData && showsData.theatreName        
      }</div>
      {
        showsData.movieList && showsData.movieList.map((movie)=>{
          return <div key={movie._id} className="movieCont">
            <div className="movieName">{movie.movieName}</div>
            <div className="movieTiming">
              {
                movie.showTimingsAndSeats.map((time)=>{
                  return <div key={time._id} className="timePills">{time.showTime}</div>
                })
              }
            </div>
          </div>
        })
      }
      </div>
      <Link to="/admin/addtheatre" className='admintheatreCard addtheatreCard'>
          <span className="plus">+</span>
          <span>Add Theatre</span>
      </Link>
      {
        theatreList && theatreList.map((theatre)=>{
            return <div key={theatre._id} className="admintheatreCard">
                <div className="name">{theatre.name}</div>
                <div className="faci">{
                    theatre.facilities.map((f, i)=>{
                        return <div key={i} className="faciPills">{f}</div>
                    })
                }</div>

                

                <Link to={"/admin/addshow/" + theatre._id} >
                    <button className="showBtn">Add shows</button>
                </Link>
                <button className="showBtn getshowBtn" onClick={()=>{getShows(theatre._id)}}>My shows</button>
            </div>
        })
      }
    </div>}
    </div>
  )
}

export default GetAllTheatres
